import React from "react";
import { motion } from "framer-motion";

export const Roadmap = ({ phases }) => (
  <div data-testid="implementation-roadmap">
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {phases.map((p, i) => (
        <motion.div
          key={p.phase}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35, delay: i * 0.08 }}
          className="relative rounded-xl border border-white/10 p-5"
          style={{ backgroundColor: "#0F1424" }}
        >
          <div className="flex items-center gap-2 mb-3">
            <span className="h-8 w-8 rounded-full bg-[#1E6BFF] text-white flex items-center justify-center text-sm font-bold">
              {p.phase}
            </span>
            <span className="text-xs uppercase tracking-wide text-[#66B2FF] font-semibold">
              {p.timeframe}
            </span>
          </div>
          <h4 className="text-white font-semibold text-sm">{p.title}</h4>
          <p className="text-white/60 text-xs mt-2 leading-relaxed">{p.description}</p>
        </motion.div>
      ))}
    </div>
  </div>
);

export default Roadmap;
